function initInternalBack(elements, defaultHref) {
  const currentUrl = new URL(location.href);
  const origin = currentUrl.origin;
  const referrer = document.referrer;

  if (referrer && referrer.startsWith(origin)) {
    elements.forEach(el => {
      el.addEventListener('click', () => {
        history.back();
      });
    })
  }
  else {
    elements.forEach(el => {
      el.href = defaultHref;
    })
  }
}
